export default function convertEnumToSelectOptions<T extends Record<string, string>>(val: T) {
  return Object.keys(val).map(key => {
    return {
      id: val[key],
      value: key
    };
  }) as Array<{
    id: keyof T;
    value: string;
  }>;
}
